import { isLogin } from "@/utils/common.js";
import bus from "@/utils/eventBus.js";

/**
 * 需要登录才能进行的操作，统一用这个包一层。
 * 已登录：直接执行 action。
 * 未登录：弹登录窗，登录成功后自动执行 action，不用页面自己判断登录状态、自己弹窗。
 *
 * 用法：this.requireLogin(() => { this.doSomething() })
 */
export function requireLogin(action) {
  if (isLogin()) {
    action && action();
    return;
  }
  bus.$emit("show-login", { onSuccess: action });
}
